<template>
	<div>
		<case-form :schema="schemaShared" class="mt6" />
		<case-form :schema="schemaLiabilities" class="mt6" />
		<case-form :schema="schemaExtra" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schemaShared() {
			return [
				{
					label: `收入表是否与别人共有、共享？(负债)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesIsSharedCN`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesIsSharedCN`
						},
						createOptions: {
							type: `liabilitiesIsSharedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>如选择"是"，请完成以下问题：</div>`
					},
					bindTo: ""
				},
				{
					label: `共有、共享人士（说明关系）：`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesSharedWithCN`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesSharedWithCN`
						},
						createOptions: {
							type: `liabilitiesSharedWithCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `比例（%）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesSharedRatioCN`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesSharedRatioCN`
						},
						createOptions: {
							type: `liabilitiesSharedRatioCN`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaLiabilities() {
			return [
				{
					label: `个人贷款 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesPersonalLoansCN`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesPersonalLoansCN`
						},
						createOptions: {
							type: `liabilitiesPersonalLoansCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `个人贷款 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesMarginAccountCN`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesMarginAccountCN`
						},
						createOptions: {
							type: `liabilitiesMarginAccountCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `个人贷款 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesLoanGuaranteesCN`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesLoanGuaranteesCN`
						},
						createOptions: {
							type: `liabilitiesLoanGuaranteesCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `房屋抵押贷款 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesMortgagesCN`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesMortgagesCN`
						},
						createOptions: {
							type: `liabilitiesMortgagesCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `其他（请说明）(美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesOtherCN`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesOtherCN`
						},
						createOptions: {
							type: `liabilitiesOtherCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `总负债 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesTotalCN`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesTotalCN`
						},
						createOptions: {
							type: `liabilitiesTotalCN`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaExtra() {
			return [
				{
					label: `您投保的目的是否与业务有关？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isPurposeOfInsuranceRelatedToBusinessCN`,
					props: {
						suggest: {
							typeIncludes: `isPurposeOfInsuranceRelatedToBusinessCN`
						},
						createOptions: {
							type: `isPurposeOfInsuranceRelatedToBusinessCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `在过去5年内，您是否曾宣布或申请个人或公司破产？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDeclaredOrPetitionedForBankruptcyCN`,
					props: {
						suggest: {
							typeIncludes: `hasDeclaredOrPetitionedForBankruptcyCN`
						},
						createOptions: {
							type: `hasDeclaredOrPetitionedForBankruptcyCN`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `如果“是”，请说明日期和细节：`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankruptcyDetailsCN`,
					props: {
						suggest: {
							typeIncludes: `bankruptcyDetailsCN`
						},
						createOptions: {
							type: `bankruptcyDetailsCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
